import { io } from 'socket.io-client';

class SocketService {
  constructor() {
    if (!SocketService.instance) {
      this.socket = null;
      this.listeners = {}; // Objet des listeners enregistrés par nom
      this.connectedUsers = []; // Liste des utilisateurs connectés
      SocketService.instance = this;
    }

    return SocketService.instance;
  }

  connect(url, profile) {
    if (!this.socket) {
      this.socket = io(url, { transports: ['websocket'] });

      this.socket.on('connect', () => {
        console.log('Connected to Socket.IO server');
        this.socket.emit('register', {
          userId: profile?._id,
          email: profile?.email,
        });
      });

      this.socket.on('disconnect', () => {
        console.log('Disconnected from Socket.IO server');
      });

      Object.keys(this.listeners).forEach((event) => {
        this.socket.on(event, this.listeners[event]);
      });
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      console.log('Socket disconnected');
    }
  }

  onNotification(event, callback) {
    this.listeners[event] = callback;
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  offNotification(event) {
    if (this.listeners[event]) {
      delete this.listeners[event];

      // Si la socket est connectée, on retire l'écouteur
      if (this.socket) {
        this.socket.off(event);
      }
    }
  }
  emit(event, data) {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  getSocket() {
    return this.socket;
  }
}

const socketService = new SocketService();
export default socketService;
